// 🔧 map_step.js
// ✅ Purpose: Map Builder pipeline step
// ✅ Features:
// - Executes the Map Builder
// - Updates DemoContext
// - Keeps venue creation modular
// - Fully block-commented for clarity and future devs

import {
  createPipelineStepSuccess,
} from "../pipeline_step";

import {
  buildVenueShell,
} from "../../builders/map_builder";

export const createMapStep =
() => ({
  name: "map_builder",

  label: "Map Builder",

  run: async (context) => {
    const result =
      await buildVenueShell(
        context
      );

    return createPipelineStepSuccess({
      step:
        "map_builder",

      label:
        "Map Builder",

      created:
        result?.createdCount || 0,

      message:
        result?.message,

      metadata:
        result,

      startedAt:
        context.startedAt,
    });
  },

  afterSuccess:
    ({
      result,
      sharedContext,
    }) => {
      sharedContext.mapResult =
        result?.metadata || null;
    },
});